import React, { Children } from 'react';
import { TabComponent, Tabs } from '@biq/apex-ui';
import { EmptyStateContainerProps } from 'components/empty-state-container/EmptyStateContainer';
import { themeObject } from 'lib';
import { alpha } from '@mui/system';

export interface HeaderButtonConfig {
    sx?: React.CSSProperties;
    icon?: string | React.ReactElement;
    label?: string;
    onClick?: () => void;
}

export type TabItemsType = {
    label: string;
    tabHeaderConfig?: {
        headingText: string;
        headerButtonsConfig?: HeaderButtonConfig[];
    };
    isError?: boolean;
    icon?: string | React.ReactElement;
    isEmptyState?: boolean;
    emptyStateConfig?: EmptyStateContainerProps & {
        hasAddButton?: boolean;
        addButtonLabel?: string;
        handleAddButtonClick?: () => void;
    };
    tabContent?: React.ReactNode;
};

interface TabsComponentProps {
    selectedTab: any;
    onTabChange: (event: React.SyntheticEvent, newValue: any) => void;
    tabItems: TabItemsType[];
    tabsStyles?: any;
    tabItemStyles?: any;
}

export const TabsComponent = ({
    selectedTab,
    onTabChange,
    tabItems,
    tabsStyles = {},
    tabItemStyles = {},
}: TabsComponentProps): React.JSX.Element => {
    const errorTabBackground = alpha(
        `${themeObject.palette.tertiary.red[300]}`,
        0.12
    );
    return (
        <Tabs
            color='primary'
            orientation='horizontal'
            tabsType='pill'
            value={selectedTab}
            onChange={onTabChange}
            sx={tabsStyles}
        >
            {Children.toArray(
                tabItems.map((tab: TabItemsType) => (
                    <TabComponent
                        label={tab.label}
                        value={tab.label}
                        isError={tab?.isError}
                        sx={{
                            ...tabItemStyles,
                            ...(tab?.isError && {
                                background: `${errorTabBackground} !important`,
                                color: `${themeObject.palette.tertiary.red[900]} !important`,
                            }),
                        }}
                        icon={tab.icon}
                        iconPosition='end'
                        color='primary'
                    />
                ))
            )}
        </Tabs>
    );
};
